/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the BSD 3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { FunctionalComponent, h } from '@stencil/core';
import { getString } from '../../utils/l10n';
import { FortifyStatus } from '../fortify-status';
import { FortifyButtonText } from '../fortify-button-text';
import { InsertTokenIllustration } from './insert_token_illustration';

export interface FortifyProvidersEmptyProps {
  helpPageLink: string;
  onCancel: (event: MouseEvent) => void;
}

export const FortifyProvidersEmpty: FunctionalComponent<FortifyProvidersEmptyProps> = (props) => {
  const { onCancel, helpPageLink } = props;

  return (
    <FortifyStatus
      title={getString('insert.title')}
      illustration={(
        <InsertTokenIllustration />
      )}
    >
      <FortifyButtonText
        href={helpPageLink}
        variant="default"
      >
        {getString('actions.needHelp')}
      </FortifyButtonText>
      <FortifyButtonText
        onClick={onCancel}
      >
        {getString('actions.dontHaveOne')}
      </FortifyButtonText>
    </FortifyStatus>
  );
};
